/**
 * Destacados de la tienda online como carrusel automático (pedido de Samuel,
 * 2026-10-19): con 3 tarjetas en rejilla los clientes creían que eso era todo
 * el menú. El carrusel admite más platos y se lee como una sección aparte.
 */

/** Tope de tarjetas del carrusel (antes eran 3 fijas). */
export const FEATURED_MAX = 8
/** Cada cuánto pasa sola a la siguiente tarjeta. */
export const FEATURED_AUTOPLAY_MS = 4000

type Candidate = {
  image_url: string | null
  is_available: boolean | null
  is_display_featured?: boolean | null
}

/**
 * Misma regla de siempre, con más cupo: los marcados como Destacado que tengan
 * foto y se puedan vender; si hay menos de 2 marcados, los primeros con foto.
 * Menos de 2 en total ⇒ [] (la sección no se pinta).
 */
export function pickFeatured<T extends Candidate>(
  items: T[],
  sellable: (i: T) => boolean,
  max: number = FEATURED_MAX,
): T[] {
  const withPhoto = items.filter((i) => i.image_url && i.is_available !== false && sellable(i))
  const flagged = withPhoto.filter((i) => i.is_display_featured)
  const picked = (flagged.length >= 2 ? flagged : withPhoto).slice(0, max)
  return picked.length >= 2 ? picked : []
}

/** Índice de la siguiente tarjeta; al final vuelve a la primera. */
export function nextSlide(current: number, count: number): number {
  return count > 0 ? (current + 1) % count : 0
}

/**
 * Qué tarjeta está "a la vista" según el scroll de la pista: la más cercana a
 * su borde izquierdo. `offsets` = offsetLeft de cada tarjeta relativo a la pista.
 * Las últimas tarjetas nunca llegan a su offset (el scroll tiene tope): en el
 * tope cuenta como la última, si no el carrusel se trabaría antes del final.
 */
export function slideAtScroll(scrollLeft: number, offsets: number[], maxScroll = Infinity): number {
  if (offsets.length > 0 && maxScroll > 0 && scrollLeft >= maxScroll - 2) return offsets.length - 1
  let best = 0
  for (let i = 1; i < offsets.length; i++) {
    if (Math.abs(offsets[i] - scrollLeft) < Math.abs(offsets[best] - scrollLeft)) best = i
  }
  return best
}
